import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

import { ConnectSubjectStep } from "@/components/login/ConnectSubjectStep"
import { useSession } from "@/store/session"

// Keep this as a dedicated route so an authenticated user without a linked
// OTK subject can complete the connection flow outside the login screen.
export function ConnectSubject() {
  const navigate = useNavigate()
  const subjectId = useSession((s) => s.user?.subjectId)

  useEffect(() => {
    if (subjectId) navigate("/", { replace: true })
  }, [subjectId, navigate])

  if (subjectId) return null

  return <ConnectSubjectStep />
}
